import React from "react";
import { Helmet } from "react-helmet";
import "../styles/TermsPolicy.css";
import HomeFooter from "../components/Home/HomeFooter";
import MainHeader from "../components/Main/MainHeader";

export default function TermsPolicy() {
  return (
    <>
    <MainHeader />
    <div className="termspolicy">
      {/* SEO Meta */}
      <Helmet>
  <title>Terms & Conditions | Anyworq – A to Z Services in Bangalore</title>
  <meta
    name="description"
    content="Read Anyworq’s Terms & Conditions, Refund & Payment Policy, and Service Agreement Guidelines. Trusted platform for A to Z services in Bangalore."
  />
  <meta name="robots" content="index, follow" />
  <meta name="title" content="Terms & Conditions | Anyworq – A to Z Services in Bangalore" />
  <link rel="canonical" href="https://www.anyworq.com/termsandconditions" />
</Helmet>


      {/* Header */}
      <header className="termspolicy-header">
        <h1>Terms & Conditions – Anyworq</h1>
        <p>
          Last Updated: September 26, 2025 <br />
          By accessing or using Anyworq (the “Platform”), you agree to be bound
          by these Terms & Conditions. If you do not agree, please do not use
          our services.
        </p>
      </header>

      {/* Section 1 */}
      <section>
        <h2>1. Use of Platform</h2>
        <ul>
          <li>
            Anyworq connects customers with verified service providers. We act
            as a facilitator and do not directly provide services.
          </li>
          <li>
            Users must provide accurate and complete information during
            registration and service requests.
          </li>
        </ul>
      </section>

      <section>
        <h2>2. User Responsibilities</h2>
        <ul>
          <li>Customers and dealers must comply with all applicable laws.</li>
          <li>
            Users are responsible for maintaining the confidentiality of their
            login credentials.
          </li>
          <li>
            Misuse of the platform, fraudulent activity, or violation of Terms
            may lead to account suspension or termination.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Service Requests</h2>
        <ul>
          <li>Anyworq facilitates service requests based on customer details.</li>
          <li>
            While we strive for accuracy, service quality or completion is the
            responsibility of the dealer.
          </li>
        </ul>
      </section>

      <section>
        <h2>4. Intellectual Property</h2>
        <ul>
          <li>
            All content, logos, and trademarks are owned by Anyworq or its
            licensors.
          </li>
          <li>Unauthorized use of content is strictly prohibited.</li>
        </ul>
      </section>

      <section>
        <h2>5. Limitation of Liability</h2>
        <p>
          Anyworq is not liable for direct, indirect, incidental, or
          consequential damages arising from service delivery, misuse of the
          platform, or third-party actions.
        </p>
      </section>

      <section>
        <h2>6. Governing Law</h2>
        <p>
          These Terms are governed by the laws of India, and any disputes will
          be resolved under the jurisdiction of Bangalore courts.
        </p>
      </section>

      {/* Refund Policy */}
      <header className="termspolicy-subheader">
        <h1>Refund & Payment Policy</h1>
        <p>Last Updated: [Insert Date]</p>
      </header>

      <section>
        <h2>1. Payment Collection</h2>
        <ul>
          <li>Payments are collected at the time of booking.</li>
          <li>
            Payments are held securely until the service is successfully
            completed.
          </li>
        </ul>
      </section>

      <section>
        <h2>2. Service Charges</h2>
        <ul>
          <li>
            A service fee is deducted before transferring the remaining amount
            to the dealer.
          </li>
          <li>All payments are processed via secure gateways.</li>
        </ul>
      </section>

      <section>
        <h2>3. Refunds</h2>
        <ul>
          <li>
            Refunds may be considered if the service is not provided or in case
            of platform errors.
          </li>
          <li>
            Requests must be sent to{" "}
            <a href="mailto:support@anyworq.com">support@anyworq.com</a> within
            7 days.
          </li>
          <li>Refunds are subject to verification and Anyworq’s discretion.</li>
        </ul>
      </section>

      <section>
        <h2>4. Disputes</h2>
        <ul>
          <li>
            Customers and dealers should first attempt amicable resolution via
            the platform.
          </li>
          <li>
            If unresolved, legal recourse may be sought as per applicable laws.
          </li>
        </ul>
      </section>

      {/* Service Agreement Guidelines */}
      <header className="termspolicy-subheader">
        <h1>Service Agreement Guidelines</h1>
      </header>

      <section>
        <h2>1. Agreement Overview</h2>
        <ul>
          <li>
            Any service request forms a binding agreement between customer and
            dealer.
          </li>
          <li>
            Both parties agree to follow platform guidelines and timelines.
          </li>
        </ul>
      </section>

      <section>
        <h2>2. Service Scope</h2>
        <ul>
          <li>Dealers must provide services as described in the request.</li>
          <li>Modifications must be mutually agreed in writing.</li>
        </ul>
      </section>

      <section>
        <h2>3. Communication</h2>
        <p>
          All communication should be conducted through the platform for
          transparency and record-keeping.
        </p>
      </section>

      <section>
        <h2>4. Payment & Completion</h2>
        <ul>
          <li>
            Payment is released only upon service completion, minus Anyworq’s
            fee.
          </li>
          <li>
            Delays, incomplete tasks, or disputes must be reported immediately.
          </li>
        </ul>
      </section>

      <section>
        <h2>5. Termination</h2>
        <p>
          Either party may terminate if obligations are not met, after notifying
          through the platform.
        </p>
      </section>

      {/* Disclaimer */}
      <header className="termspolicy-subheader">
        <h1>Disclaimer & Limitation of Liability</h1>
      </header>

      <section>
        <h2>1. General Disclaimer</h2>
        <ul>
          <li>
            Anyworq provides a platform to connect customers with service
            providers but does not directly provide services.
          </li>
          <li>
            The platform does not guarantee quality, reliability, or timeliness
            of services.
          </li>
        </ul>
      </section>

      <section>
        <h2>2. Limitation of Liability</h2>
        <p>
          Anyworq is not responsible for losses, damages, or injuries from
          services arranged via the platform. Dealers are solely responsible for
          service delivery.
        </p>
      </section>

      <section>
        <h2>3. Third-Party Links</h2>
        <p>
          Links to third-party websites are for convenience only; Anyworq is not
          liable for their content or services.
        </p>
      </section>

      <section>
        <h2>4. Indemnity</h2>
        <p>
          Users agree to indemnify and hold harmless Anyworq, its officers, and
          affiliates from claims, damages, or expenses from platform use or
          violations.
        </p>
      </section>

      <section>
        <h2>5. Governing Law</h2>
        <p>
          Governed by the laws of India, with Bangalore courts having exclusive
          jurisdiction.
        </p>
      </section>
    </div>
    <HomeFooter />
    </>
  );
}
